/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import 'react-accessible-accordion/dist/minimal-example.css';
import { bindActionCreators as bind } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { Diagnostic } from '../../data/ducks';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { FlowHeader, HEADER_HEIGHT } from '../GoalsFlow/styles';
import { LoadingImage, WhiteLogo, StyledResults } from '../shared/resultsStyles';
import Title from '../shared/Title';

import { breakpoints, palette } from '../../constants/styles';
import Section from '../landing/Section';
import Text from '../shared/Text';
import GetStarted from '../landing/GetStarted';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 50px;
  min-height: 100vh;
`;

export const ResultSection = styled(Section)`
  height: fit-content;
  justify-content: center;
  background-color: white;

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

export const FinalSection = styled(Section)`
  height: fit-content;
  justify-content: center;
  background-color: rgb(2, 39, 89);
  color: white;

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

export const CheckPointSection = styled(Section)`
  display: flex;
  width: 100%;
  height: fit-content;
  justify-content: center;
  background-color: rgb(2, 39, 89);

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

const StyledTempResult = styled.div`
  padding: 0px 20px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${HEADER_HEIGHT + 20}px;
  justify-content: flex-start;

  ${breakpoints.tablet} {
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
  }
`;

export const StyledResultTableSavings = styled.tbody`
  & > tr > th {
    padding: 0px;
    border-bottom: none;
  }
  & > tr > * {
    ${({ borderColor }) =>
      borderColor &&
      css`
        border-bottom: 1px solid ${borderColor};
      `}
    padding: 5px;
    text-align: center;

    // Colors
    &:nth-child(1) {
      width: 20px;
      text-align: left;
    }
    // Labels
    &:nth-child(2) {
      width: 50%;
      text-align: left;
    }
    // Money
    &:nth-child(3) {
      width: 30%;
      ${({ borderColor }) =>
        borderColor &&
        css`
          border-left: 1px solid ${borderColor};
        `}
    }
    // Percentage
    &:nth-child(4) {
      width: 20%;
      ${({ borderColor }) =>
        borderColor &&
        css`
          border-left: 1px solid ${borderColor};
        `}
    }
  }
`;

const StyledTempResultContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
`;

const MAX_LOADING_TIME = 10000;

class SubmitAndLoad extends Component {
  state = {
    incomeOverflow: false,
  };

  componentDidMount() {
    const { answeredSoFar, saveDiagnosticData } = this.props;

    saveDiagnosticData(answeredSoFar);
    setTimeout(
      () => (this.props.error ? this.props.history.push('/oops') : null),
      MAX_LOADING_TIME,
    );
  }

  componentWillReceiveProps(newProps) {
    const { error, loading, result, history } = newProps;
    if (!loading) {
      if (error) {
        console.log('there was an error');
      } else if (result) {
        if (result.data.incomeOverflow) {
          this.setState({ incomeOverflow: true });
        } else {
          console.log("we're good, let's move forward");
          history.push(`/plan/res/${result.data.uuid}`);
        }
      }
    }
  }

  render() {
    const { loading, answeredSoFar, error } = this.props;
    const { incomeOverflow } = this.state;
    const {
      expensesTotal,
      insurancePayment,
      creditPayment,
      savingsPayment,
      totalIncome,
    } = answeredSoFar;
    console.log('error');
    console.log(error);

    return loading && !incomeOverflow ? (
      <Fragment>
        <FlowHeader>
          <Link to="/" onClick={this.forceUpdate}>
            <WhiteLogo src={FinautaWhiteLogo} id="logo" />
          </Link>
        </FlowHeader>
        <StyledResults>
          <Container>
            <ResultSection>
              <Title level={3} medium>
                Estamos creando tu plan...
              </Title>
              <LoadingImage
                src="https://s3.us-east-2.amazonaws.com/finauta/art/load.gif"
                alt="loading..."
              />
            </ResultSection>
          </Container>
        </StyledResults>
      </Fragment>
    ) : (
      <StyledTempResultContainer>
        <FlowHeader>
          <Title
            level={5}
            color="white"
            styles={css`
              margin-bottom: 0px;
            `}
            medium
          >
            ¡Oops!
          </Title>
        </FlowHeader>
        <StyledTempResult>
          <Title level={4} align="center">
            No logramos cuadrar tus ingresos y egresos.
          </Title>
          <Title level={6} style={{ marginBottom: '1.5em' }} align="center">
            ¿Nos ayudas verificando tu información?
          </Title>
          <Text type="body1" align="left" style={{ alignSelf: 'flex-start' }} medium>
            Tus ingresos y egresos mensuales:
          </Text>
          <table
            cellPadding={0}
            cellSpacing={0}
            style={{ width: '100%', margin: '10px 0px 0px 0px' }}
          >
            <StyledResultTableSavings borderColor={palette.sweetGray}>
              <tr>
                <th />
                <th />
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Ingresos</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color={palette.secondaryColor} align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={totalIncome}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Gastos reportados</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={expensesTotal * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Creditos</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={creditPayment * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Seguros</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={insurancePayment * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Ahorro</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={savingsPayment * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: 'none' }}>
                  <Text type="body1" bold>
                    Total
                  </Text>
                </td>
                <td align="center" style={{ borderBottom: 'none' }}>
                  <Text type="body1" color="red" bold align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={
                        totalIncome -
                        expensesTotal -
                        creditPayment -
                        insurancePayment -
                        savingsPayment
                      }
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
            </StyledResultTableSavings>
          </table>
          <Text type="body1" style={{ marginTop: '1em' }}>
            El total (
            <NumberFormat
              style={{ color: 'red', fontWeight: '700' }}
              value={
                totalIncome - expensesTotal - creditPayment - insurancePayment - savingsPayment
              }
              displayType="text"
              thousandSeparator
              prefix="$"
              decimalScale={0}
            />
            ) debería ser mayor o igual a <b>$0</b>.
          </Text>
          <GetStarted
            showFree
            event="Restart form"
            title="Reiniciar formulario"
            to="https://app.finauta.com/plan"
            incentiveColor="white"
          />
        </StyledTempResult>
      </StyledTempResultContainer>
    );
  }
}

SubmitAndLoad.propTypes = {
  result: PropTypes.object,
  answeredSoFar: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  saveDiagnosticData: PropTypes.func,
};

SubmitAndLoad.defaultProps = {
  result: {},
  answeredSoFar: {},
  loading: true,
  error: false,
  saveDiagnosticData: () => {},
};

const mapStateToProps = (state) => ({
  result: state.diagnostic.result,
  loading: state.diagnostic.loading,
  error: state.diagnostic.error,
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      saveDiagnosticData: Diagnostic.Creators.saveDiagnosticDataRequested,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubmitAndLoad));
